import moment from "moment"

const FORMAT = "DD.MM.YYYY"

const isInRange = (date: string, min: string, max: string): boolean =>
  moment(date, FORMAT).isBetween(moment(min, FORMAT), moment(max, FORMAT), undefined, "[]")

const outOfRangeMessage = (date: string, label: string, min: string, max: string): string =>
  moment(date, FORMAT).isSameOrAfter(moment(max, FORMAT))
    ? `${label} не позднее ${max}`
    : `${label} не ранее ${min}`

// Проверка даты начала проекта: в границах сезона и строго раньше даты окончания
export const validateProjectStart = (
  date: string,
  endDate: string | undefined,
  min: string,
  max: string
): boolean | string => {
  if (!moment(date, FORMAT, true).isValid()) {
    return "Введите корректную дату"
  }
  if (!isInRange(date, min, max)) {
    return outOfRangeMessage(date, "Дата начала", min, max)
  }
  return moment(date, FORMAT).isBefore(moment(endDate, FORMAT))
    ? true
    : "Дата начала не может быть позже даты окончания или совпадать с ней"
}

// Проверка даты окончания проекта: в границах сезона и строго позже даты начала
export const validateProjectEnd = (
  date: string,
  startDate: string | undefined,
  min: string,
  max: string
): boolean | string => {
  if (!moment(date, FORMAT, true).isValid()) {
    return "Введите корректную дату"
  }
  if (!isInRange(date, min, max)) {
    return outOfRangeMessage(date, "Дата окончания", min, max)
  }
  return moment(date, FORMAT).isAfter(moment(startDate, FORMAT))
    ? true
    : "Дата окончания не может быть раньше даты начала или совпадать с ней"
}
